import { FC, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button } from '@progress/kendo-react-buttons'
import { Window } from '@progress/kendo-react-dialogs'
import { StackLayout } from '@progress/kendo-react-layout'

import { SearchBody } from '../../../components/layouts'
import { BuildingSearchCondition } from './BuildingSearchCondition'
import { BuildingSearchResultList } from './BuildingSearchResultList'
import { BuildingRegistration } from '../maintenance/BuildingRegistration'
import { useAccessibleAuthority, usePageTitle, useLeaveGuard } from '../../../components/hooks'
import {
  ConfirmDialog,
  ErrorMessage,
  ErrorMessages
} from '../../../components/parts'

import { BuildingMaintenanceGateway } from '../../../gateway/building/BuildingMaintenanceGateway'
import { BuildingSearchGateway } from '../../../gateway/building/BuildingSearchGateway'
import { BuildingReportGateway } from '../../../gateway/building/BuildingReportGateway'
import { BuildingReplaceGateway } from '../../../gateway/building/BuildingReplaceGateway'
import { Authority } from '../../../gateway/system/Authority'

import {
  BuildingSearchActions,
  CommonActions,
  useAppDispatch,
  useAppSelector
} from '../../../stores'
import {
  BuildingInfoGet,
  BuildingInfoPut,
  GetBuildingSearchReqObj,
  GetBuildingSearchResObj,
  PutBuildingItemReqObj,
  PutBuildingReplaceReq
} from '@gateway.Building'
import { BlobFileService, MessageProvider } from '../../../services'
import produce from 'immer'

const BUILDING_SEARCH_DATA: GetBuildingSearchResObj = {
  buildingInfoList: []
}

const BUILDING_SEARCH_REQ_PARAMS: GetBuildingSearchReqObj = {
  procurementNo: '',
  buildingNo: '',
  obtainFyList: [],
  obtainHistoryCdList: [],
  constructionFormCdList: [],
  evaluationValueCdList: [],
  effortLevelCdList: [],
  choiceAndConcentrationTarget: [],
  procurementStsList: [],
  updStsList: [],
  yamadumiFlg: [],
  kenzaiDiscloseFlg: [],
  supplierDiscloseFlg: [],
  completedFlg: [],
  reportNonTargetFlg: [],
  updUserKbn: [],
  updUserStr: '',
  updDateFrom: '',
  updDateTo: '',
  branchCdList: [],
  constructionNm: '',
  constructionNmDuplication: [],
  constructionSectionNm: '',
  chiefPersonNm: '',
  hqSalesSectionNm: '',
  hqSalesPersonNm: '',
  branchSalesSectionNm: '',
  branchSalesPersonNm: '',
  totalCostFrom: null,
  totalCostTo: null,
  ourCompanyTotalCostFrom: null,
  ourCompanyTotalCostTo: null,
  scheduleYFrom: '',
  scheduleYTo: '',
  constructionCdList: [],
  architectureUse: '',
  structureUndergroundList: [],
  structureGroundList: [],
  specialConstructionMethod: '',
  remark: '',
  expenseOnCdList: [],
  expenseOffCdList: [],
  sortOrder: '1',
  constructionSubjectCdExist: [],
  sagyosyoCdExist: [],
  buildingNoExist: []
}

const BUILDING_INFO_PUT_INIT: BuildingInfoPut = {
  simulationYm: null,
  buildingNo: null,
  procurementNo: null,
  subNo: null,
  branchCd: null,
  expense: null,
  expenseSeq: null,
  branchNm: null,
  constructionKbn: null,
  constructionKbnNm: null,
  constructionNm: null,
  dispConstructionNm: null,
  opportunityProgressCd: null,
  opportunityProgress: null,
  privateDecisionFlg: null,
  constructionFormCd: null,
  dispConstructionFormCd: null,
  obtainHistoryCd: null,
  dispObtainHistoryCd: null,
  evaluationCd: null,
  evaluation: null,
  evaluationValueCd: null,
  evaluationValue: null,
  customerPartnershipCd: null,
  customerCd: null,
  customerNm: null,
  dispCustomerNm: null,
  collabCustomerPartnershipCd: null,
  collabCustomerCd: null,
  collabCustomerNm: null,
  dispCollabCustomerNm: null,
  designerCustomerPartnershipCd: null,
  designerCustomerCd: null,
  designerNm: null,
  dispDesignerNm: null,
  designKbn: null,
  dispDesignKbn: null,
  designKbnNm: null,
  dispDesignKbnNm: null,
  totalCost: null,
  dispTotalCost: null,
  ourCompanyTotalCost: null,
  dispOurCompanyTotalCost: null,
  ourCompanyEquityRatio: null,
  dispOurCompanyEquityRatio: null,
  obtainYM: null,
  obtainFY: '',
  dispObtainFY: '',
  constructionSubjectCd: null,
  dispConstructionSubjectCd: null,
  constructionSectionCd: null,
  constructionSectionNm: null,
  dispConstructionSectionNm: null,
  chiefPersonCd: null,
  chiefPersonEmployeeNo: null,
  chiefPersonNm: null,
  dispChiefPersonNm: null,
  chiefPersonContacts: null,
  dispChiefPersonContacts: null,
  hqSalesSectionCd: null,
  hqSalesSectionNm: null,
  dispHqSalesSectionNm: null,
  hqSalesPersonCd: null,
  hqSalesPersonEmployeeNo: null,
  hqSalesPersonNm: null,
  dispHqSalesPersonNm: null,
  hqSalesPersonContacts: null,
  dispHqSalesPersonContacts: null,
  branchSalesSectionCd: null,
  branchSalesSectionNm: null,
  dispBranchSalesSectionNm: null,
  branchSalesPersonCd: null,
  branchSalesPersonEmployeeNo: null,
  branchSalesPersonNm: null,
  dispBranchSalesPersonNm: null,
  branchSalesPersonContacts: null,
  dispBranchSalesPersonContacts: null,
  prefecture: null,
  dispPrefecture: null,
  city: null,
  dispCity: null,
  startYM: null,
  startY: '',
  startM: '',
  dispStartYM: null,
  completionYM: null,
  completionY: '',
  completionM: '',
  dispCompletionYM: null,
  schedule: null,
  dispSchedule: null,
  planSummary: null,
  buildingServicesWorkFlg: null,
  dispBuildingServicesWorkFlg: null,
  constructionCd: null,
  dispConstructionCd: null,
  architectureUse: null,
  totalFloorAreaM2: null,
  dispTotalFloorAreaM2: null,
  totalFloorAreaTsubo: null,
  dispTotalFloorAreaTsubo: null,
  siteAreaM2: null,
  dispSiteAreaM2: null,
  siteAreaTsubo: null,
  dispSiteAreaTsubo: null,
  structureCd: null,
  structureUnderGround: null,
  dispStructureUnderGround: null,
  structureGround: null,
  dispStructureGround: null,
  structurePenthouse: null,
  dispStructurePenthouse: null,
  floorUnderGround: null,
  dispFloorUnderGround: null,
  floorGround: null,
  dispFloorGround: null,
  floorPenthouse: null,
  dispFloorPenthouse: null,
  specialConstructionMethod: null,
  dispSpecialConstructionMethod: null,
  piling: null,
  seismicIsolation: null,
  topDownFlg: null,
  fixComment: null,
  architectureUseCd1: null,
  architectureUseNm1: null,
  architectureUseCd2: null,
  architectureUseNm2: null,
  architectureUseCd3: null,
  architectureUseNm3: null,
  analyzationArchitectureUseCd1: null,
  analyzationArchitectureUseNm1: null,
  analyzationArchitectureUseCd2: null,
  analyzationArchitectureUseNm2: null,
  analyzationArchitectureUseCd3: null,
  analyzationArchitectureUseNm3: null,
  effortLevelCd: null,
  dispEffortLevelCd: null,
  effortLevel: null,
  dispEffortLevel: null,
  coreTopFlg: null,
  dispCoreTopFlg: null,
  choiceAndConcentrationTarget: null,
  dispChoiceAndConcentrationTarget: null,
  sagyosyoCd: null,
  dispSagyosyoCd: null,
  yamadumiNotApplicableYm: null,
  importDtm: null,
  addUserKbn: null,
  addDtm: null,
  addUserCd: null,
  updUserKbn: null,
  updDtm: null,
  updUserCd: null,
  delFlg: 0,
  yamadumiFlg: 0,
  kenzaiDiscloseFlg: 0,
  supplierDiscloseFlg: 0,
  completedFlg: 0,
  reportNonTargetFlg: 0,
  procurementSts: null,
  updSts: null,
  remark: null,
  modeKbn: '0'
}

export const BuildingSearch: FC = () => {
  useAccessibleAuthority(Authority.Builder, Authority.Material, Authority.Branch, Authority.Supplier)

  usePageTitle('物件情報一覧')

  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  const searchConditionStore = useAppSelector((state) => state.buildingsearch.buildingSearchCondition)
  const searchDataStore = useAppSelector((state) => state.buildingsearch.buildingSearchData)

  // ログイン情報の取得
  const userProp = useAppSelector((state) => state.common.userProp)

  const isSupplier = userProp?.authority === Authority.Supplier

  const [searchConditionState, setSearchConditionState] = useState(BUILDING_SEARCH_REQ_PARAMS)

  const [showRegistrationDialog, setShowRegistrationDialog] = useState(false)
  // 新規登録State
  const [buildingRegistrationState, setBuildingRegistrationState] = useState<BuildingInfoPut>(BUILDING_INFO_PUT_INIT)

  // メッセージ表示用state
  const [errorMessages, setErrorMessages] = useState<ErrorMessage[]>([])
  const [notificationMessages, setNotificationMessages] = useState<ErrorMessage[]>([])

  /* Dialog */
  const [confirmDialogShow, setConfirmDialogShow] = useState(false)
  const [title, setTitle] = useState('')
  const [args, setArgs] = useState([''])
  const [confirmDialogId, setConfirmDialogId] = useState('')

  // 物件情報（表示用）
  const [buildingSearchDataStore, setBuildingSearchDataStore] = useState<GetBuildingSearchResObj>(BUILDING_SEARCH_DATA)
  // 物件情報（フラグ情報管理用）
  const [buildingSearchDataState, setBuildingSearchDataState] = useState<GetBuildingSearchResObj>(BUILDING_SEARCH_DATA)
  // 物件情報（物件情報メンテナンス起動前）
  const [buildingInfoBefore, setBuildingInfoBefore] = useState<BuildingInfoPut>(BUILDING_INFO_PUT_INIT)
  // スキップ明細数
  const [skip, setSkip] = useState(0)
  // 選択物件
  const [target, setTarget] = useState('')
  // 付替元物件
  const [sourceBuilding, setSourceBuilding] = useState('')
  // 付替先物件
  const [destinationBuilding, setDestinationBuilding] = useState('')

  // 付替ボタン
  const [replaceButtonDisabled, setReplaceButtonDisabled] = useState(true)
  // 確定ボタン
  const [okButtonDisabled, setOkButtonDisabled] = useState(true)
  // 戻るボタン
  const [goBackButtonDisabled, setGoBackButtonDisabled] = useState(true)
  // 出力ボタン
  const [reportButtonDisabled, setReportButtonDisabled] = useState(true)
  // 新規登録ボタン
  const [addSignInButtonDisabled, setAddSignInButtonDisabled] = useState(true)
  // 変更検知
  const [isChanged, setIsChanged] = useState(false)
  // 山積対象指定選択可否
  const [disabledConditionYamadumiFlg, setDisabledConditionYamadumiFlg] = useState(false)
  // 建材部公開指定選択可否
  const [disabledConditionKenzaiDiscloseFlg, setDisabledConditionKenzaiDiscloseFlg] = useState(false)

  // 親物件の件数
  const searchDataStorLength = searchDataStore.buildingInfoList
    .filter((item) => item.buildingInfo.subNo === '00')
    .length

  const [, resetLeaveGuard] = useLeaveGuard(
    [isChanged],
    '内容が編集中です。このページを離れますか？'
  )

  const toggleRegistrationDialog = () => {
    setBuildingInfoBefore(buildingRegistrationState)
    setShowRegistrationDialog(!showRegistrationDialog)
  }

  /**
   * オブジェクト比較
   */
  const ObjCompare = (obj1: BuildingInfoPut, obj2: BuildingInfoPut) => {
    const obj1Keys = Object.keys(obj1) as Array<keyof BuildingInfoPut>
    const obj2Keys = Object.keys(obj2) as Array<keyof BuildingInfoPut>
    if (obj1Keys.length !== obj2Keys.length) {
      return false
    }
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
    for (const k of obj1Keys as Array<keyof BuildingInfoPut>) {
      if (obj1[k] !== obj2[k]) {
        return false
      }
    }
    return true
  }

  /**
   *クリア
   */
  const handleClearBtnClick = () => {
    const currentSearchCondition = Object.assign({}, BUILDING_SEARCH_REQ_PARAMS)

    // ログイン情報．利用者権限＝工務（コード＝2）の場合
    if (userProp?.authority === Authority.Builder) {
      // 支店
      currentSearchCondition.branchCdList = []
    }
    // ログイン情報．利用者権限＝支店（コード＝4）の場合
    if (userProp?.authority === Authority.Branch) {
      // 支店
      currentSearchCondition.branchCdList = [userProp?.branchCode]
      // 山積対象指定
      currentSearchCondition.yamadumiFlg = [1]
      // 山積対象指定は操作不可にする
      setDisabledConditionYamadumiFlg(true)
      // 建材部公開指定
      currentSearchCondition.kenzaiDiscloseFlg = [1]
      // 建材部公開指定は操作不可にする
      setDisabledConditionKenzaiDiscloseFlg(true)
    }
    // ログイン情報．利用者権限＝建材部（コード＝3）、または業者（コード＝5）の場合
    if (
      userProp?.authority === Authority.Material ||
      userProp?.authority === Authority.Supplier
    ) {
      // 支店
      currentSearchCondition.branchCdList = []
    }
    setSearchConditionState(currentSearchCondition)

    // Storeに検索条件の同期
    dispatch(
      BuildingSearchActions.setBuildingSearchCondition({
        ...currentSearchCondition
      })
    )
  }

  /**
   * BuildingSearchGatewayのThenのロジック処理
   * @param searchData
   * @returns
   */
  const handleBuildingSearchThenLogic = (
    searchData: GetBuildingSearchResObj
  ) => {
    // No.1_検索結果存在チェック
    if (searchData.buildingInfoList.length === 0) {
      //  0件の場合は下記のメッセージを表示し、明細部の設定は行いません。
      setNotificationMessages([
        {
          id: 'I001',
          content: MessageProvider.provide('I001', ...[])
        }
      ])
    } else if (searchData.buildingInfoList.length > 1000) {
      // 1001件の場合は下記のメッセージを表示し、1000件目までを明細部に設定します。
      setNotificationMessages([
        {
          id: 'I015',
          content: MessageProvider.provide('I015', ...['1000'])
        }
      ])

      searchData.buildingInfoList = searchData.buildingInfoList.slice(0, 1000)
    }
    // ボタン部の新規作成ボタン、戻るボタンを活性、その他のボタンは非活性にする
    // 新規作成ボタンは活性に設定する
    setAddSignInButtonDisabled(false)
    // 戻るボタンは活性に設定する
    setGoBackButtonDisabled(false)
    // 付替えボタンは非活性に設定する
    setReplaceButtonDisabled(true)
    // 確定ボタンは非活性に設定する
    setOkButtonDisabled(true)
    // 出力ボタンは活性に設定する
    setReportButtonDisabled(false)
    // 付替情報の初期化
    setSourceBuilding('')
    setDestinationBuilding('')

    setBuildingSearchDataState({ ...searchData })
    // 検索条件として指定されたパラメータを条件に情報をDBから取得して、データストアに格納する
    dispatch(
      BuildingSearchActions.setBuildingSearchData({
        ...searchData
      })
    )
    // 検索に使用した検索条件をデータストアに格納する
    dispatch(
      BuildingSearchActions.setBuildingSearchCondition({
        ...searchConditionState
      })
    )
    dispatch(CommonActions.setIsLoading(false))
  }

  /**
   * 検索(stateの検索条件を使用)
   */
  const handleSearchBtnClick = () => {
    dispatch(CommonActions.setIsLoading(true))
    setSkip(0)
    setTarget('')
    BuildingSearchGateway.GetBuildingList(searchConditionState)
      .then((res) => {
        if (res.error) {
          if (Array.isArray(res.messages) && res.messages.length > 0) {
            const errorMessages = res.messages.map<ErrorMessage>((message) => {
              return {
                id: message.id,
                content: message.message
              }
            })
            dispatch(CommonActions.setIsLoading(false))
            setErrorMessages(errorMessages)
          }
        } else {
          const searchData = res.data ?? BUILDING_SEARCH_DATA
          // Thenのロジック処理
          handleBuildingSearchThenLogic(searchData)
        }
      })
      .catch((e) => {
        dispatch(CommonActions.setIsLoading(false))
        throw e
      })
  }

  /**
   * 検索(storeの検索条件を使用)
   */
  const handleSearchBtnClickStore = () => {
    dispatch(CommonActions.setIsLoading(true))
    BuildingSearchGateway.GetBuildingList(searchConditionStore)
      .then((res) => {
        if (res.error) {
          if (Array.isArray(res.messages) && res.messages.length > 0) {
            const errorMessages = res.messages.map<ErrorMessage>((message) => {
              return {
                id: message.id,
                content: message.message
              }
            })
            dispatch(CommonActions.setIsLoading(false))
            setErrorMessages(errorMessages)
          }
        } else {
          const searchData = res.data ?? BUILDING_SEARCH_DATA
          // Thenのロジック処理
          handleBuildingSearchThenLogic(searchData)
        }
      })
      .catch((e) => {
        dispatch(CommonActions.setIsLoading(false))
        throw e
      })
  }

  /**
   * 付替
   */
  const handleReplace = () => {
    setConfirmDialogShow(true)
    setTitle('付替')
    setConfirmDialogId('I007')
    const args = ['物件情報の付替']
    setArgs(args)
  }

  /**
   * 確定
   */
  const handleConfirm = () => {
    setConfirmDialogShow(true)
    setTitle('確定')
    setConfirmDialogId('I002')
    const args = ['山積対象選択、建材部公開指定、業者公開指定、竣工済指定、帳票対象外指定', '確定']
    setArgs(args)
  }

  /**
   * 出力（社内版）
   */
  const handleInput = () => {
    setConfirmDialogShow(true)
    setTitle('出力（社内版）')
    setConfirmDialogId('I007')
    const args = ['物件情報一覧の出力']
    setArgs(args)
  }

  /**
   * 出力（業者版）
   */
  const handleInputSupplier = () => {
    setConfirmDialogShow(true)
    setTitle('出力（業者版）')
    setConfirmDialogId('I007')
    const args = ['物件情報一覧の出力']
    setArgs(args)
  }

  /**
   * 新規登録
   */
  const toggleRegistrationDialogLogin = () => {
    setConfirmDialogShow(true)
    setTitle('物件情報の新規登録')
    setConfirmDialogId('I002')
    setArgs(['物件情報', '登録'])
  }

  /**
   * 新規登録画面での戻る
   */
  const toggleRegistrationDialogReturn = () => {
    const diff = ObjCompare(buildingInfoBefore, buildingRegistrationState)
    if (!diff) {
      setConfirmDialogShow(true)
      setTitle('確認')
      setConfirmDialogId('I003')
    } else {
      toggleRegistrationDialog()
      // 入力内容の初期化を行う
      setBuildingRegistrationState(BUILDING_INFO_PUT_INIT)
      setBuildingInfoBefore(BUILDING_INFO_PUT_INIT)
    }
  }

  /**
   * 戻る
   */
  const handleOnClickReturn = () => {
    navigate(-1)
  }

  /* Dialog 確認ボタン  */
  const handleConfirmEvent = () => {
    setConfirmDialogShow(false)
    const putBuildingItemReqObj: PutBuildingItemReqObj = {
      data: {
        buildingInfoList: []
      }
    }
    const args: string[] = []
    let id = ''
    if (title === '物件情報の新規登録' || title === '確定') {
      dispatch(CommonActions.setIsLoading(true))
      if (title === '物件情報の新規登録') {
        const buildingInfoPut = { ...buildingRegistrationState }
        // 建材部登録物件、または支店登録物件の場合は山積シミュレーションを実行するため、
        // 山積対象フラグ、建材部公開フラグをONにしてリクエストする
        if (userProp?.authority === Authority.Material || userProp?.authority === Authority.Branch) {
          buildingInfoPut.yamadumiFlg = 1
          buildingInfoPut.kenzaiDiscloseFlg = 1
        }

        putBuildingItemReqObj.data.buildingInfoList.push({
          buildingInfo: buildingInfoPut,
          flgChg: 0,
          updDtmBuildingHistoryStatus: null,
          updDtmParentBuildingHistoryStatus: null
        })
        args.push('物件情報の登録')
        id = 'I004'
      } else if (title === '確定') {
        setOkButtonDisabled(true)
        buildingSearchDataStore.buildingInfoList.forEach((obj, index) => {
          let buildingInfoPut = Object.assign({}, BUILDING_INFO_PUT_INIT)
          const dispStartYM = obj.buildingInfo.dispStartYM ?? ''
          const dispCompletionYM = obj.buildingInfo.dispCompletionYM ?? ''
          buildingInfoPut = {
            ...obj.buildingInfo,
            simulationYm: null,
            expense: null,
            expenseSeq: null,
            modeKbn: null,
            // 着工年 startY
            startY: dispStartYM === '' ? dispStartYM : dispStartYM.substring(0, 4),
            // 着工月 startM
            startM: dispStartYM === '' ? dispStartYM : dispStartYM.substring(4, dispStartYM.length),
            // 竣工年 completionY
            completionY: dispCompletionYM === '' ? '' : dispCompletionYM.substring(0, 4),
            // 竣工月 completionM
            completionM: dispCompletionYM === '' ? '' : dispCompletionYM.substring(4, dispCompletionYM.length),
            // 山積対象フラグ yamadumiFlg
            yamadumiFlg: buildingSearchDataState.buildingInfoList[index].buildingInfo.yamadumiFlg,
            // 建材部公開フラグ kenzaiDiscloseFlg
            kenzaiDiscloseFlg: buildingSearchDataState.buildingInfoList[index].buildingInfo.kenzaiDiscloseFlg,
            // 業者公開フラグ supplierDiscloseFlg
            supplierDiscloseFlg: buildingSearchDataState.buildingInfoList[index].buildingInfo.supplierDiscloseFlg,
            // 竣工済フラグ completedFlg
            completedFlg: buildingSearchDataState.buildingInfoList[index].buildingInfo.completedFlg,
            // 帳票対象外フラグ reportNonTargetFlg
            reportNonTargetFlg: buildingSearchDataState.buildingInfoList[index].buildingInfo.reportNonTargetFlg
          }
          if (buildingSearchDataState.buildingInfoList[index].buildingInfo.isChanged) {
            putBuildingItemReqObj.data.buildingInfoList.push({
              buildingInfo: buildingInfoPut,
              flgChg: 1,
              updDtmBuildingHistoryStatus: buildingSearchDataState.buildingInfoList[index].buildingInfo.updDtmBuildingHistoryStatus,
              updDtmParentBuildingHistoryStatus: null
            })
          }
        })
      }
      let error = false
      BuildingMaintenanceGateway.putBuildingItem(putBuildingItemReqObj)
        .then((_res) => {
          error = _res.error
          if (!error) {
            const autoYamadumiNotPossibleBuildingList = _res.data.autoYamadumiNotPossibleBuildingList
            if (autoYamadumiNotPossibleBuildingList.length > 0) {
              const requiredLackList: string[] = []
              const mismatchList: string[] = []
              for (const autoYamadumiNotPossibleBuilding of autoYamadumiNotPossibleBuildingList) {
                const { requiredLackBuildingList, mismatchBuildingList } = autoYamadumiNotPossibleBuilding
                if (requiredLackBuildingList.length > 0) {
                  requiredLackBuildingList.forEach((item) => {
                    requiredLackList.push(`${item.procurementNo}-${item.subNo}`)
                  })
                }
                if (mismatchBuildingList.length > 0) {
                  mismatchBuildingList.forEach((item) => {
                    mismatchList.push(`${item.procurementNo}-${item.subNo}`)
                  })
                }
              }
              if (requiredLackList.length > 0 && mismatchList.length > 0) {
                setErrorMessages([
                  {
                    id: 'I005',
                    content: MessageProvider.provide(
                      'I005',
                      ...[requiredLackList.join(',')]
                    )
                  },
                  {
                    id: 'I006',
                    content: MessageProvider.provide(
                      'I006',
                      ...[mismatchList.join(',')]
                    )
                  }
                ])
              }
              if (requiredLackList.length > 0 && mismatchList.length === 0) {
                setErrorMessages([
                  {
                    id: 'I005',
                    content: MessageProvider.provide(
                      'I005',
                      ...[requiredLackList.join(',')]
                    )
                  }
                ])
              }
              if (requiredLackList.length === 0 && mismatchList.length > 0) {
                setErrorMessages([
                  {
                    id: 'I006',
                    content: MessageProvider.provide(
                      'I006',
                      ...[mismatchList.join(',')]
                    )
                  }
                ])
              }
              if (requiredLackList.length === 0 && mismatchList.length === 0) {
                if (title === '物件情報の新規登録') {
                  args.push('物件情報の登録')
                  id = 'I004'
                  setNotificationMessages([
                    {
                      id,
                      content: MessageProvider.provide(id, ...args)
                    }
                  ])
                }
                if (title === '確定') {
                  args.push('山積対象選択、建材部公開指定、業者公開指定、竣工済指定、帳票対象外指定の確定')
                  id = 'I004'
                  setNotificationMessages([
                    {
                      id,
                      content: MessageProvider.provide(id, ...args)
                    }
                  ])
                  // Storeにある検索条件で物件情報の再検索を行う
                  handleSearchBtnClickStore()
                }
              }
              if (title === '物件情報の新規登録') {
                setShowRegistrationDialog(!showRegistrationDialog)
                // Storeにある検索条件で物件情報の再検索を行う
                handleSearchBtnClickStore()
                // 入力内容の初期化を行う
                setBuildingRegistrationState(BUILDING_INFO_PUT_INIT)
              }
              if (title === '確定') {
                if (isChanged) {
                  resetLeaveGuard()
                }
              }
            } else {
              if (title === '物件情報の新規登録') {
                args.push('物件情報の登録')
                id = 'I004'
                setNotificationMessages([
                  {
                    id,
                    content: MessageProvider.provide(id, ...args)
                  }
                ])
                setShowRegistrationDialog(!showRegistrationDialog)
                // 入力内容の初期化を行う
                setBuildingRegistrationState(BUILDING_INFO_PUT_INIT)
              }
              if (title === '確定') {
                if (isChanged) {
                  resetLeaveGuard()
                }
                args.push('山積対象選択、建材部公開指定、業者公開指定、竣工済指定、帳票対象外指定の確定')
                id = 'I004'
                setNotificationMessages([
                  {
                    id,
                    content: MessageProvider.provide(id, ...args)
                  }
                ])
              }
            }
          } else {
            if (title === '確定') {
              const resMessages = _res.messages
              if (Array.isArray(resMessages) && resMessages.length > 0) {
                const errorMessages = resMessages.map<ErrorMessage>((message: any) => {
                  return {
                    id: message.id,
                    content: message.message
                  }
                })
                setErrorMessages(errorMessages)
              } else {
                args.push('山積対象選択、建材部公開指定、業者公開指定、竣工済指定、帳票対象外指定の確定')
                id = 'E003'
                const errMessages = [
                  {
                    id,
                    content: MessageProvider.provide(id, ...args)
                  }
                ]
                setErrorMessages(errMessages)
              }
            } else {
              const resMessages = _res.messages
              if (Array.isArray(resMessages) && resMessages.length > 0) {
                const errorMessages = resMessages.map<ErrorMessage>((message: any) => {
                  return {
                    id: message.id,
                    content: message.message
                  }
                })
                setErrorMessages(errorMessages)
              }
            }
          }
        })
        .finally(() => {
          setOkButtonDisabled(false)
          dispatch(CommonActions.setIsLoading(false))
          if (!error) {
            // エラーではない場合、Storeにある検索条件で物件情報の再検索を行う
            handleSearchBtnClickStore()
          }
        })
    } else {
      if (title === '確認') {
        toggleRegistrationDialog()
        // 入力内容の初期化を行う
        setBuildingRegistrationState(BUILDING_INFO_PUT_INIT)
      } else if (title === '出力（社内版）' || title === '出力（業者版）') {
        dispatch(CommonActions.setIsLoading(true))
        setReportButtonDisabled(true)
        const supplierFormatFlag = title === '出力（業者版）' ? 1 : 0
        BuildingReportGateway.GetBuildingListReport(supplierFormatFlag, searchConditionStore)
          .then((res) => {
            if (res.error) {
              const args = ['物件情報一覧の出力']
              const errMessages = [
                {
                  id: 'E003',
                  content: MessageProvider.provide('E003', ...args)
                }
              ]
              setErrorMessages(errMessages)
            } else {
              if (isChanged) {
                resetLeaveGuard()
              }
              BlobFileService.downloadRedirectTo(res.data)
              const args = ['物件情報一覧出力']
              setNotificationMessages([
                {
                  id: 'I004',
                  content: MessageProvider.provide('I004', ...args)
                }
              ])
            }
          })
          .finally(() => {
            setReportButtonDisabled(false)
            dispatch(CommonActions.setIsLoading(false))
          })
      } else if (title === '付替') {
        setReplaceButtonDisabled(true)
        const source = sourceBuilding.split('_')
        const destination = destinationBuilding.split('_')
        const putBuildingReplaceReq: PutBuildingReplaceReq = {
          data: {
            sourceBuilding: {
              procurementNo: source[0],
              subNo: source[1],
              updDtm: source[2]
            },
            destinationBuilding: {
              procurementNo: destination[0],
              subNo: destination[1],
              updDtm: destination[2]
            }
          }
        }
        let error = false
        BuildingReplaceGateway.putBuildingReplace(putBuildingReplaceReq)
          .then((res) => {
            error = res.error
            if (error) {
              const resMessages = res.messages
              if (Array.isArray(resMessages) && resMessages.length > 0) {
                const messages = resMessages.map<ErrorMessage>((message) => {
                  return {
                    id: message.id,
                    content: message.message
                  }
                })
                setErrorMessages(messages)
              }
            } else {
              if (isChanged) {
                resetLeaveGuard()
              }
              const args = ['物件情報の付替']
              setNotificationMessages([
                {
                  id: 'I004',
                  content: MessageProvider.provide('I004', ...args)
                }
              ])
            }
          })
          .finally(() => {
            setReplaceButtonDisabled(false)
            dispatch(CommonActions.setIsLoading(false))
            if (!error) {
            // エラーではない場合、Storeにある検索条件で物件情報の再検索を行う
              handleSearchBtnClickStore()
            }
          })
      }
    }
  }

  const setBuildingInfoList = (params: GetBuildingSearchResObj, skip: number, propsTake?: number) => {
    let preProNo: string | null = ''
    let curTake = 0
    let skipFlg = true
    let skipProcurementNo: string | null = ''

    // 指定されたページの調達番号の先頭
    if (skip !== 0) {
      skipProcurementNo = params.buildingInfoList
        .filter((v) => v.buildingInfo.subNo === '00')[skip]
        .buildingInfo.procurementNo
    }

    const buildingInfoList = params.buildingInfoList.map((v) => {
      const buildingInfo = v.buildingInfo

      // 先頭の調達番号までスキップ
      if (
        skip !== 0 &&
        skipProcurementNo !== buildingInfo.procurementNo &&
        skipFlg
      ) {
        return null
      }

      skipFlg = false

      // 調達番号が同じ物件情報の枝番（子）が00の物件情報を親、01~99の物件情報を子として扱う
      if (preProNo === buildingInfo.procurementNo) {
        if (buildingInfo.subNo === '00') {
          curTake++
        }
        preProNo = buildingInfo.procurementNo
        return v
      } else if (curTake < 20) {
        if (buildingInfo.subNo === '00') {
          curTake++
        }
        preProNo = buildingInfo.procurementNo
        return v
      } else {
        preProNo = ''
        return null
      }
    }).filter(v => v) as Array<{
      buildingInfo: BuildingInfoGet
    }>

    setBuildingSearchDataStore({ ...params, buildingInfoList })
    setBuildingSearchDataState({ ...params, buildingInfoList })

    setSkip(skip)
  }

  const setSkipBuilding = (skip: number) => {
    setBuildingInfoList(searchDataStore, skip)
  }

  useEffect(() => {
    // 利用者の権限=「工務」、「建材部」または「支店担当者」の場合
    if (
      userProp?.authority === Authority.Builder ||
      userProp?.authority === Authority.Material ||
      userProp?.authority === Authority.Branch
    ) {
      // ボタン部の「戻る、出力、新規登録」ボタンは活性に設定する
      setGoBackButtonDisabled(false)
      setAddSignInButtonDisabled(false)
      setReportButtonDisabled(false)
      // 確定ボタンは非活性に設定する
      setOkButtonDisabled(true)
    }

    // 利用者の権限=「業者」の場合
    if (userProp?.authority === Authority.Supplier) {
      // ボタン部: 「出力」「戻る」は活性、「新規登録」「確定」は非表示で設定
      setReportButtonDisabled(false)
      setGoBackButtonDisabled(false)
    }
  }, [userProp?.authority])

  useEffect(() => {
    // 初期検索条件の値を設定
    const newSearchCondition = produce(BUILDING_SEARCH_REQ_PARAMS, (draft) => {
      // ログイン情報．利用者権限＝工務（コード＝2）の場合
      if (userProp?.authority === Authority.Builder) {
        // 支店
        draft.branchCdList = []
      }
      // ログイン情報．利用者権限＝支店（コード＝4）の場合
      if (userProp?.authority === Authority.Branch) {
        // 支店
        draft.branchCdList = [userProp?.branchCode]
        // 山積対象指定
        draft.yamadumiFlg = [1]
        // 山積対象指定は操作不可にする
        setDisabledConditionYamadumiFlg(true)
        // 建材部公開指定
        draft.kenzaiDiscloseFlg = [1]
        // 建材部公開指定は操作不可にする
        setDisabledConditionKenzaiDiscloseFlg(true)
      }
      // ログイン情報．利用者権限＝建材部（コード＝3）、または業者（コード＝5）の場合
      if (
        userProp?.authority === Authority.Material ||
        userProp?.authority === Authority.Supplier
      ) {
        // 支店
        draft.branchCdList = []
      }
    })

    setSearchConditionState(newSearchCondition)

    let ignore = false

    // 初期検索条件でBuildingSearchGatewayを呼び出す
    dispatch(CommonActions.setIsLoading(true))
    BuildingSearchGateway.GetBuildingList(newSearchCondition)
      .then((res) => {
        if (!ignore) {
          if (res.error) {
            if (Array.isArray(res.messages) && res.messages.length > 0) {
              const errorMessages = res.messages.map<ErrorMessage>((message) => {
                return {
                  id: message.id,
                  content: message.message
                }
              })
              setErrorMessages(errorMessages)
            }
          } else {
            const searchData = res.data ?? BUILDING_SEARCH_DATA
            // No.1_検索結果存在チェック
            if (searchData.buildingInfoList.length === 0) {
              //  0件の場合は下記のメッセージを表示し、明細部の設定は行いません。
              setNotificationMessages([
                {
                  id: 'I001',
                  content: MessageProvider.provide('I001', ...[])
                }
              ])
              return
            } else if (searchData.buildingInfoList.length > 1000) {
              // 1001件の場合は下記のメッセージを表示し、1000件目までを明細部に設定します。
              setNotificationMessages([
                {
                  id: 'I015',
                  content: MessageProvider.provide('I015', ...['1000'])
                }
              ])

              searchData.buildingInfoList = searchData.buildingInfoList.slice(
                0,
                1000
              )
            }
            // ボタン部の新規作成ボタン、戻るボタンを活性、その他のボタンは非活性にする
            // 新規作成ボタンは活性に設定する
            setAddSignInButtonDisabled(false)
            // 戻るボタンは活性に設定する
            setGoBackButtonDisabled(false)
            // 確定ボタンは非活性に設定する
            setOkButtonDisabled(true)
            // 出力ボタンは活性に設定する
            setReportButtonDisabled(false)

            setBuildingSearchDataState({ ...searchData })
            // 検索条件として指定されたパラメータを条件に情報をDBから取得して、データストアに格納する
            dispatch(
              BuildingSearchActions.setBuildingSearchData({
                ...searchData
              })
            )
            // 検索に使用した検索条件をデータストアに格納する
            dispatch(
              BuildingSearchActions.setBuildingSearchCondition({
                ...newSearchCondition
              })
            )
          }
        }
      })
      .finally(() => {
        dispatch(CommonActions.setIsLoading(false))
      })

    return () => {
      ignore = true
    }
  }, [dispatch, userProp?.authority, userProp?.branchCode])

  useEffect(() => {
    setBuildingInfoList(searchDataStore, skip)
  }, [searchDataStore])

  useEffect(() => {
    if (sourceBuilding !== '' && destinationBuilding !== '') {
      setReplaceButtonDisabled(false)
    } else {
      setReplaceButtonDisabled(true)
    }
  }, [sourceBuilding, destinationBuilding])

  return (
    <>
      <SearchBody
        total={searchDataStorLength}
        changeSkipBuilding={(skip: number) => setSkipBuilding(skip)}
        skip={skip}
        leftPane={
          <BuildingSearchCondition
            searchConditionState={searchConditionState}
            setSearchConditionState={setSearchConditionState}
            userProp={userProp}
            disabledConditionYamadumiFlg={disabledConditionYamadumiFlg}
            disabledConditionKenzaiDiscloseFlg={disabledConditionKenzaiDiscloseFlg}
          />
        }
        leftPaneButton={
          <>
            <Button onClick={handleClearBtnClick}>クリア</Button>
            <Button themeColor="primary" onClick={handleSearchBtnClick}>
              検索
            </Button>
          </>
        }
        rightPane={
          <BuildingSearchResultList
            skip={skip}
            userProp={userProp}
            onSearchBtnClick={handleSearchBtnClickStore}
            setBuildingSearchData={setBuildingSearchDataState}
            setOkButtonDisabled={setOkButtonDisabled}
            buildingSearchDataState={buildingSearchDataState}
            buildingSearchDataStore={buildingSearchDataStore}
            setNotificationMessages={setNotificationMessages}
            setErrorMessages={setErrorMessages}
            setIsChanged={setIsChanged}
            setBuildingSearchDataState={setBuildingSearchDataState}
            target={target}
            setTarget={setTarget}
            sourceBuilding={sourceBuilding}
            setSourceBuilding={setSourceBuilding}
            destinationBuilding={destinationBuilding}
            setDestinationBuilding={setDestinationBuilding}
          />
        }
        rightPaneButton={
          <>
            <Button
              disabled={goBackButtonDisabled}
              onClick={handleOnClickReturn}
            >
              戻る
            </Button>
            {!isSupplier && (
              <Button
                disabled={reportButtonDisabled}
                onClick={handleInput}
                themeColor="primary"
              >
                出力（社内版）
              </Button>
            )}
            <Button
              disabled={reportButtonDisabled}
              onClick={handleInputSupplier}
              themeColor="primary"
            >
              {!isSupplier ? '出力（業者版）' : '出力'}
            </Button>
            {isSupplier
              ? (
              <></>
                )
              : (
              <>
                <Button
                  disabled={addSignInButtonDisabled}
                  onClick={toggleRegistrationDialog}
                  themeColor="primary"
                >
                  新規登録
                </Button>
                <Button
                  disabled={replaceButtonDisabled}
                  onClick={handleReplace}
                  themeColor="primary"
                >
                  付替
                </Button>
                <Button
                  disabled={okButtonDisabled}
                  onClick={handleConfirm}
                  themeColor="primary"
                >
                  確定
                </Button>
              </>
                )}
          </>
        }
      />

      {showRegistrationDialog && (
        <Window
          title={'物件情報メンテナンス新規登録'}
          onClose={toggleRegistrationDialogReturn}
          initialWidth={1280}
          initialHeight={720}
          modal
        >
          <BuildingRegistration
            setBuildingRegistration={setBuildingRegistrationState}
            buildingRegistration={buildingRegistrationState}
          />
          <StackLayout
            orientation="horizontal"
            align={{ horizontal: 'end' }}
            gap={5}
          >
            <Button
              className="pcy-button-long"
              onClick={toggleRegistrationDialogReturn}
            >
              戻る
            </Button>
            <Button
              className="pcy-button-long"
              themeColor="primary"
              onClick={toggleRegistrationDialogLogin}
            >
              登録
            </Button>
          </StackLayout>
        </Window>
      )}
      {confirmDialogShow && (
        <ConfirmDialog
          open={confirmDialogShow}
          title={title}
          id={confirmDialogId}
          args={args}
          onClickOk={handleConfirmEvent}
          onClickCancel={() => setConfirmDialogShow(false)}
        />
      )}
      <ErrorMessages type="notification" messages={notificationMessages} />
      <ErrorMessages type="dialog" messages={errorMessages} />
    </>
  )
}
